const appCategories = [
  {
    path: '/app-categories',
    name: 'app-categories',
    component: () => import('@/views/appCategories/index.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_application_settings',
      resource: 'all',
    },
  },
  {
    path: '/app-categories/create',
    name: 'create-app-categories',
    component: () => import('@/views/appCategories/create.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_application_settings',
      resource: 'all',
    },
  },
  {
    path: '/app-categories/edit/:id',
    name: 'edit-app-categories',
    component: () => import('@/views/appCategories/edit.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_application_settings',
      resource: 'all',
    },
  },
  {
    path: '/app-collections',
    name: 'app-collections',
    component: () => import('@/views/appCollections/index.vue'),
    meta: {
      layout: 'content',
      requiresAuth: true,
      action: 'can_see_application_settings',
      resource: 'all',
    },
  },
]

export default appCategories
